module.exports = __webpack_public_path__ + "img/midfi-3.5f66ee01.png";